// extracted by mini-css-extract-plugin
export default {"IMAGE_SIZE":"26px","imageSize":"26px","container":"_34pQM","image":"_1XeAM"};